import {Component, Input} from "@angular/core";
import {PartnerItem} from "../../../service/page/page";

@Component({
  selector: 'app-partner-link-item',
  templateUrl: './partner-link-item.component.html',
  styleUrls: ['./partner-link-item.component.scss']
})
export class PartnerLinkComponent{

  @Input() link: PartnerItem;

  href: string;
}



// WEBPACK FOOTER //
// ./src/app/heyground/partners/partner-link-item/partner-link-item.component.ts